export var ActiveReferrersSortByEnum;
(function (ActiveReferrersSortByEnum) {
    ActiveReferrersSortByEnum["REFERRAL_COUNT"] = "REFERRAL_COUNT";
    ActiveReferrersSortByEnum["TOTAL_INCOME"] = "TOTAL_INCOME";
    ActiveReferrersSortByEnum["EXCHANGE_BASED_INCOME"] = "EXCHANGE_BASED_INCOME";
    ActiveReferrersSortByEnum["VERIFICATION_BASED_INCOME"] = "VERIFICATION_BASED_INCOME";
})(ActiveReferrersSortByEnum || (ActiveReferrersSortByEnum = {}));
//# sourceMappingURL=active-referrers-sort-by.enum.js.map